import { render, staticRenderFns } from "./manufacturing-vendor-form.vue?vue&type=template&id=40327612&scoped=true&"
import script from "./manufacturing-vendor-form.vue?vue&type=script&lang=js&"
export * from "./manufacturing-vendor-form.vue?vue&type=script&lang=js&"
import style0 from "./manufacturing-vendor-form.vue?vue&type=style&index=0&id=40327612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40327612",
  null
  
)

export default component.exports